export const LocalActivityIcon = ({ color = "#8D8D8D", size = 20, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
    {...props}
  >
    <g clip-path="url(#clip0_13135_10220)">
      <path
        d="M17.5 10.5C17.5 9.58334 18.25 8.83334 19.1667 8.83334V5.50001C19.1667 4.58334 18.4167 3.83334 17.5 3.83334H4.16667C3.25 3.83334 2.50833 4.58334 2.50833 5.50001V8.83334C3.425 8.83334 4.16667 9.58334 4.16667 10.5C4.16667 11.4167 3.425 12.1667 2.5 12.1667V15.5C2.5 16.4167 3.25 17.1667 4.16667 17.1667H17.5C18.4167 17.1667 19.1667 16.4167 19.1667 15.5V12.1667C18.25 12.1667 17.5 11.4167 17.5 10.5ZM13.8167 14.5L10.8333 12.5833L7.85 14.5L8.75 11.0667L6.00833 8.82501L9.54167 8.61668L10.8333 5.33334L12.1167 8.62501L15.65 8.83334L12.9083 11.075L13.8167 14.5Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_13135_10220">
        <rect
          width={size}
          height={size}
          fill="white"
          transform="translate(0.833252 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
